import { render } from "./NcrmWorkflowExternalFormEditor.vue?vue&type=template&id=193db7e2&scoped=true"
import script from "./NcrmWorkflowExternalFormEditor.vue?vue&type=script&lang=js"
export * from "./NcrmWorkflowExternalFormEditor.vue?vue&type=script&lang=js"

import "./NcrmWorkflowExternalFormEditor.vue?vue&type=style&index=0&id=193db7e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-193db7e2"]])

export default __exports__